export const emailInstructionMessage = (email: string) => {
	const isEduEmail = email.endsWith(".edu");
	return `If you do not receive an email, check your junk, spam, and recently deleted folders${isEduEmail ? ", or contact your IT administrator" : ""}`;
};
